import {getGWTIsQueryMode} from '../../../_shared/GWTBridge/invoke/formTable';
import {formsStore} from '../../Form/stores/FormsStore';

export const getIsQueryMode = () => {
    if (formsStore.isReactView) {
        return formsStore.currentForm.queryMode;
    } else {
        return getGWTIsQueryMode();
    }
};
